import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import About from './pages/About';
import Education from './pages/Education';
import Resume from './pages/Resume';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/education" element={<Education />} />
          <Route path="/resume" element={<Resume />} />
        </Routes>
        <footer className="footer">
          <p>&copy; 2026 Jasmin Meghan R. Malolos. All rights reserved.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
